import { render, staticRenderFns } from "./consulting.vue?vue&type=template&id=6bb170d6&"
import script from "./consulting.vue?vue&type=script&lang=js&"
export * from "./consulting.vue?vue&type=script&lang=js&"
import style0 from "./consulting.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "consulting.vue"
export default component.exports